import React, { useState, useMemo, Fragment, useRef, useLayoutEffect, useEffect } from 'react';
import useToggleExpand from "../Hooks/UseToggleExpand";

export const AccordionPanel = (props) => props;

export const CustomAccordion = ({ header, content, children, icon, className }) => {
    const elementRef = useRef(null);

    const { expanded, expand, recalculateHeight } = useToggleExpand(false);

    useEffect(() => {
        let resizeTimer;

        const handleResize = () => {
            if(expanded){
                recalculateHeight(elementRef);
            }
        };

        // Add event listener for window resize start
        window.addEventListener('resize', handleResize);

        // Clean up the event listener and timer on component unmount
        return () => {
            window.removeEventListener('resize', handleResize);
            clearTimeout(resizeTimer);
        };
    }, [expanded]);


    return (
        <Fragment>
            <button className="custom-accordion__button" onClick={() => expand(elementRef)}>
                {header}

                <span className={"custom-accordion__icon " + (expanded ? "custom-accordion__icon--active" : "")}>
                    {icon && icon}
                </span>
            </button>

            <div className="custom-accordion__content" ref={elementRef}>
                {content}
            </div>
        </Fragment>
    )
};
